const featureFlag = 'FeatureFlag';

export const FETCH_CHANGE_LOG = `${featureFlag}/FETCH_CHANGE_LOG`;
export const FETCH_CHANGE_LOG_ERROR = `${featureFlag}/FETCH_CHANGE_LOG_ERROR`;
export const FETCH_CHANGE_LOG_RESPONSE = `${featureFlag}/FETCH_CHANGE_LOG_RESPONSE`;

export const FETCH_FEATURE_FLAGS = `${featureFlag}/FETCH_FEATURE_FLAGS`;
export const FETCH_FEATURE_FLAGS_ERROR = `${featureFlag}/FETCH_FEATURE_FLAGS_ERROR`;
export const FETCH_FEATURE_FLAGS_RESPONSE = `${featureFlag}/FETCH_FEATURE_FLAGS_RESPONSE`;

export const SAVE_FEATURE_FLAG = `${featureFlag}/SAVE_FEATURE_FLAG`;
export const SAVE_FEATURE_FLAG_ERROR = `${featureFlag}/SAVE_FEATURE_FLAG_ERROR`;

export const FETCH_USERS_ERROR = `${featureFlag}/FETCH_USERS_ERROR`;
export const FETCH_USERS_REQUEST = `${featureFlag}/FETCH_USERS_REQUEST`;
export const FETCH_USERS_RESPONSE = `${featureFlag}/FETCH_USERS_RESPONSE`;
